import { useState } from "react";
import { toast } from "sonner";
import { Truck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const STATUSES = ["processing", "shipped", "delivered", "cancelled"];

export const OrderStatusDialog = ({ order, auth, onDone }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ status: order.fulfilment_status || "processing", courier: order.courier || "", tracking_number: order.tracking_number || "" });
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.patch(`/admin/orders/${order.id}/status`, f, auth);
      toast.success(data.emailed ? `Updated — customer emailed (${f.status})` : "Updated (status unchanged, no email)");
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Update failed");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="h-7" data-testid={`order-update-btn-${order.id}`}><Truck className="w-3.5 h-3.5 mr-1" />Update</Button>
      </DialogTrigger>
      <DialogContent className="bg-white" aria-describedby={undefined} data-testid="order-status-dialog">
        <DialogHeader><DialogTitle>Update order — {order.customer_name}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-2">
            {STATUSES.map((s) => (
              <button key={s} type="button" onClick={() => setF({ ...f, status: s })} data-testid={`order-status-${s}`}
                className={`px-3 py-2 rounded-lg border-2 text-sm font-semibold capitalize ${f.status === s ? "border-[#FF2E63] text-[#FF2E63]" : "border-slate-200"}`}>{s}</button>
            ))}
          </div>
          <Input placeholder="Courier (e.g. Delhivery, India Post)" value={f.courier} onChange={(e) => setF({ ...f, courier: e.target.value })} data-testid="order-courier-input" />
          <Input placeholder="Tracking number" value={f.tracking_number} onChange={(e) => setF({ ...f, tracking_number: e.target.value })} data-testid="order-tracking-input" />
          <p className="text-xs text-slate-500">The customer gets an email whenever the status changes.</p>
          <Button onClick={save} disabled={loading} className="w-full rs-cta rounded-full" data-testid="order-status-save-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save & notify customer"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
